import { FONTS, fontFamilyFor } from "../../theme";

export const Style = {
  heading: (isArabic) => ({
    fontFamily: isArabic ? fontFamilyFor("ar") : FONTS.heading,
    fontWeight: 700,
    fontSize: "20px",
  }),
  subHeading: (isArabic) => ({
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontWeight: 400,
    fontSize: "16px",
    color: "rgba(255,255,255,0.7)",
    width: "100%",
    maxWidth: "315px",
  }),
  button: {
    // width: "100%",
    mt: "20px",
    height: "45px",
    position: { xs: "absolute", sm: "static" },
    width: { xs: "calc(100% - 40px)", sm: "calc(100% - 3px)" },
    bottom: "20px",
    left: "20px",
  },
};
